import script from "./Spiel.vue?vue&type=script&setup=true&lang=js"
export * from "./Spiel.vue?vue&type=script&setup=true&lang=js"

import "./Spiel.vue?vue&type=style&index=0&id=9fbf7ace&lang=css"

const __exports__ = script;

export default __exports__